import { CLEAN_STATE } from 'root/src/client/logic/app/actionIds'

export default () => ({
	type: CLEAN_STATE,
})
